/** Replaces the goods string by changing the number of letters [id] with the correct amount  of letters */
const changeGoodsByKey = (goods: string, id: string, count: number) => {
  const cleanedGoods = goods.replaceAll(id, '');
  return `${cleanedGoods}${id.repeat(count)}`;
};

export default changeGoodsByKey;
